var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 312,
    viewBox: "0 0 171 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29 158)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116 128)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116 96)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116 64)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116 32)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(87 96)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(87 32)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(87)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(58 64)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(87 64)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(58 32)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(58)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(29 32)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(29)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "rgba(255,255,255,0.09)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116 32)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116 64)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116 96)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(116 128)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(87 32)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(87 96)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(87 128)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(58 64)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(87 64)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(58 96)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(58 128)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(29 96)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(29 128)",
    fill: "rgba(255,255,255,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(0 128)",
    fill: "rgba(255,255,255,0.09)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 141)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "rgba(255,255,255,0.09)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground2);
export default __webpack_public_path__ + "static/media/background_2.897f89396fddfbc360661812f23f77be.svg";
export { ForwardRef as ReactComponent };